import { Component } from "react"
import "./index.css"
import { Link } from "react-router-dom"
import Logo from "./img/xy-3.png"

class Top extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false
    };
  }

  componentDidMount() {
    // 导航栏滑动变化监听
    window.addEventListener("scroll", this.handleScroll);
    // 监听窗口大小变化，如果菜单打开时窗口变大到桌面尺寸，则关闭菜单
    window.addEventListener("resize", this.handleResize);
    // 点击文档其他地方关闭菜单
    document.addEventListener("click", this.handleDocumentClick);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  // 导航栏滑动变化监听
  handleScroll = (e) => {
    var header = document.getElementById("header")
    if (window.pageYOffset >= 80) {
      header.classList.add("header_bg")
    } else {
      header.classList.remove("header_bg")
    }
  }

  // 切换菜单开关
  toggleMenu = (e) => {
    e.stopPropagation();
    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen
    }));
  }

  // 关闭菜单
  closeMenu = (e) => {
    e.stopPropagation();
    this.setState({ isMenuOpen: false });
  }

  // 处理文档点击事件
  handleDocumentClick = (e) => {
    if (this.state.isMenuOpen) {
      this.setState({ isMenuOpen: false });
    }
  }

  // 处理窗口大小变化
  handleResize = () => {
    // 如果窗口宽度大于768px且菜单是打开的，则关闭菜单
    if (window.innerWidth > 768 && this.state.isMenuOpen) {
      this.setState({ isMenuOpen: false });
    }
  }

  render() {
    const { isMenuOpen } = this.state;

    return (
      <div className="page" id="page">
        <div className="dis-flex header" id="header">
          {/* 左侧logo和标题容器 */}
          <div className="header-left">
            <div className="header-logo">
              <img
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
                src={Logo || "/placeholder.svg"}
                alt="Logo"
              />
            </div>
            {/* 电脑端标题 */}
            <div className="header-title-desktop">
              <span className="header-title">嵌入式系统设计原理与应用</span>
            </div>
          </div>
          
          {/* 电脑端导航 */}
          <div className="dis-flex dhl-2 desktop-nav">
            <div className="bord-2 dlh-2-left menuDiv">
              <Link to="/home">
                首页
              </Link>
            </div>
            <div className="bord-2 menuDiv">
              <ul>
                <li>
                  <Link to="/course-intro">
                    课程介绍
                  </Link>
                </li>
              </ul>
            </div>
            <div className="bord-2 dlh-2-left menuDiv">
              <Link to="/projects">
                案例与教学素材
              </Link>
            </div>
            <div className="bord-2 dlh-2-left menuDiv">
              <Link to="/students">
                学生培养
              </Link>
            </div>
            <div className="bord-2 dlh-2-left menuDiv">
              <Link to="/enterprise">
                企业践习
              </Link>
            </div>
            <div className="bord-2 dlh-2-left menuDiv">
              <Link to="/faculty">
                师资建设
              </Link>
            </div>
          </div>
          
          {/* 移动端标题（居中显示） */}
          <div className="header-title-mobile">
            <span className="header-title">嵌入式系统设计原理与应用</span>
          </div>
          
          {/* 移动端菜单按钮 */}
          <div className="mobile-menu-button" onClick={this.toggleMenu}>
            <div className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          
          {/* 移动端导航菜单 */}
          {isMenuOpen && (
            <div className="mobile-nav-simple" onClick={(e) => e.stopPropagation()}>
              <div className="mobile-nav-simple-content">
                <div className="mobile-nav-simple-item">
                  <Link to="/home" onClick={this.closeMenu}>
                    首页
                  </Link>
                </div>
                <div className="mobile-nav-simple-item">
                  <Link to="/course-intro" onClick={this.closeMenu}>
                    课程介绍
                  </Link>
                </div>
                <div className="mobile-nav-simple-item">
                  <Link to="/projects" onClick={this.closeMenu}>
                    案例与教学素材
                  </Link>
                </div>
                <div className="mobile-nav-simple-item">
                  <Link to="/students" onClick={this.closeMenu}>
                    学生培养
                  </Link>
                </div>
                <div className="mobile-nav-simple-item">
                  <Link to="/enterprise" onClick={this.closeMenu}>
                    企业践习
                  </Link>
                </div>
                <div className="mobile-nav-simple-item">
                  <Link to="/faculty" onClick={this.closeMenu}>
                    师资建设
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Top